import styled from "@emotion/styled";
import {
  grayScale,
  mBody1,
  mBody2,
  mHeader1,
  mTitle1,
  swc,
  wBody2,
  wHeader2,
  wTitle2,
} from "@teamsparta/design-system";
import { DESKTOP } from "@/themes/device";

export const Wrapper = styled.section`
  margin: 0 auto;
  padding: 80px 0;
  background-color: ${grayScale.gray100};

  ${DESKTOP} {
    padding: 120px 0;
  }
`;

export const ContentWrapper = styled.section`
  ${DESKTOP} {
    max-width: 1152px;
    margin: 0 auto;
  }
`;

export const Title = styled.h2`
  width: calc(100% - 32px);
  margin: 0 auto 40px auto;
  ${mHeader1};
  color: ${grayScale.white};
  text-align: left;

  b {
    color: ${grayScale.gray70};
  }

  ${DESKTOP} {
    ${wHeader2};
    color: ${grayScale.white};
    margin: 0 0 60px;
  }
`;

export const CardsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  ${DESKTOP} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const Card = styled.section`
  margin: 0 16px;
  padding: 24px 20px;
  background-color: ${grayScale.white};
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.2s ease;
  ${DESKTOP} {
    margin: 0;
    padding: 30px 24px;
    &:hover {
      transform: translateY(-10px);
    }
  }
`;

export const CardHeader = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 12px;

  ${DESKTOP} {
    margin-bottom: 14px;
  }
`;

export const CardIcon = styled.div`
  position: relative;
  width: 52px;
  height: 52px;

  ${DESKTOP} {
    width: 64px;
    height: 64px;
  }
`;

export const CardTitleWrapper = styled.section`
  margin-left: 10px;
  height: 48px;
  ${DESKTOP} {
    margin-left: 14px;
    height: 54px;
  }
`;

export const CardTitle = styled.h5`
  ${mTitle1};
  color: ${grayScale.gray90};
  margin: 0 0 2px 0;

  ${DESKTOP} {
    ${wTitle2};
    color: ${grayScale.gray90};
  }
`;

export const CardDiscount = styled.small`
  ${mBody2};
  color: ${swc.blue};

  ${DESKTOP} {
    ${wBody2};
    color: ${swc.blue};
  }
`;

export const CardBody = styled.section`
  ${mBody2};
  color: ${grayScale.gray80};
  margin-bottom: 20px;
  height: 42px;
  white-space: pre-wrap;
  ${DESKTOP} {
    ${wBody2};
    height: 48px;
    color: ${grayScale.gray80};
  }
`;

export const CardButton = styled.button`
  width: 100%;
  height: 44px;
  ${mBody1};
  color: ${grayScale.gray0};
  background-color: ${swc.blue};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
`;
